export default __webpack_public_path__ + "static/media/cagepackage.c513fbc2.png";